import HeaderAdministrator from '@gruponewway/aquisicao-base-header-administrator';
import '@gruponewway/aquisicao-base-header-administrator/dist/index.css';

export default HeaderAdministrator;
